import React from "react"
import { generalStyles as gs } from "../../styles/styles"

const FIELDS = [
	{ key: "label", label: "Label" },
	{ key: "telephone", label: "Téléphone" },
	{ key: "email", label: "E-mail" },
]

// Reusable V2 "Identité" section for an entity. `update(key, value)`.
const EntiteIdentiteV2 = ({ entite, update, updateExtraData }) => {
	const extraData = entite.extra_data || {}
	return (
		<div style={gs.card}>
			<div style={gs.cardTitle}>Identité</div>
			<div style={gs.fieldGroup}>
				{FIELDS.map((f) => (
					<div key={f.key} style={gs.fieldRow}>
						<label style={gs.label}>{f.label}</label>
						<input
							style={gs.input}
							value={entite[f.key] || ""}
							onChange={(e) => update(f.key, e.target.value)}
						/>
					</div>
				))}
				{updateExtraData && (
					<div style={gs.fieldRow}>
						<label style={gs.label}>E-mail de test</label>
						<input
							style={gs.input}
							type="email"
							placeholder="adresse pour les envois de test"
							value={extraData.email_test || ""}
							onChange={(e) =>
								updateExtraData("email_test", e.target.value)
							}
						/>
					</div>
				)}
			</div>
		</div>
	)
}

export default EntiteIdentiteV2
